{
    "AgentList_AddButton_DisabledTooltip": "Selecione um servidor de telefonia e uma partição nos filtros acima para adicionar um agente.",
    "AgentList_Column_AgentNumber": "Número do agente",
    "AgentList_Column_PartitionId": "ID da partição",
    "AgentList_Column_Monitored": "Monitorado",
    "AgentList_Monitored_Yes": "Sim",
    "AgentList_Monitored_No": "Não",
    "AgentList_Column_Description": "Descrição",
    "AgentList_Column_InternalNumber": "Número interno",
    "AgentList_Column_PartitionName": "Nome da partição",
    "AgentList_Column_OmniChannel": "Omnicanal",
    "NAME": "AgentListLanguage"
}